<template>
    <div class="app-wrapper" >
        <navbar></navbar>
        <app-main></app-main>
    </div>
</template>

<script>
	import { Navbar, AppMain } from './components'

	export default {
		name: 'layout',
		components: {
			Navbar,
			AppMain,
		},
	}
</script>

<style scoped>

    .app-wrapper {
        margin: 0;
        padding: 0;
        position: relative;
        height: 100%;
        width: 100%;
    }

    body {
        font-size: 12px;
        line-height: 1.5;
        background: #e9eaeb;
        color: #000;
    }

</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue